import { useEffect } from "react";
import { queryClient } from "../../../App";
import { HttpClientError } from "../../../providers/HttpClient";
import useEmployeeImportJobFinalizeApiService from "../services/api/EmployeeImportJobFinalizeApiService";
import { useToasts } from "../../../providers/notifications/ToastsContext";

export default function FinalizeEmployeeImportJobHook(): {
  finalizeEmployeeImportJob: (
    employerId: number,
    jobId: number,
    batchId: string
  ) => void;
} {
  const { isSuccess, isError, mutate, error } =
    useEmployeeImportJobFinalizeApiService();
  const { showToast } = useToasts();

  const finalizeEmployeeImportJob = (
    employerId: number,
    jobId: number,
    batchId: string
  ): void => {
    mutate({ job_id: jobId, employer_id: employerId, batch_id: batchId });
  };

  useEffect(() => {
    if (isError) {
      showToast({
        strapiId: "employee_import_job_finalize_failed",
        data: { message: HttpClientError(error) },
      });
    }
  }, [isError, error]);

  useEffect(() => {
    if (isSuccess) {
      showToast({ strapiId: "employee_import_job_finalize_success" });
      queryClient.invalidateQueries(["EmployeeImportJobListApiService"]).then();
    }
  }, [isSuccess]);

  return {
    finalizeEmployeeImportJob,
  };
}
